/**
 * HTTP status codes used for error handling.
 * Use these instead of magic numbers for consistency and discoverability.
 */
export enum HttpStatus {
  BAD_REQUEST = 400,
  UNAUTHORIZED = 401,
  FORBIDDEN = 403,
  NOT_FOUND = 404,
  CONFLICT = 409,
  UNPROCESSABLE_ENTITY = 422,
  PRECONDITION_REQUIRED = 428,
  INTERNAL_SERVER_ERROR = 500,
}
